import gql from 'graphql-tag';

const CLUB_TRANSFER_REQUEST_RESPOND_AS_CLUB= gql`
mutation clubTransferRequestRespondAsClub($id: ID!, $clubId: ID!, $result:ResponseResult ) {
  clubTransferRequestRespondAsClub(id: $id, clubId: $clubId, result: $result) {
    id
    bid
  }
}
`;

export default CLUB_TRANSFER_REQUEST_RESPOND_AS_CLUB;